import React, { useEffect, useState, memo } from 'react';
import { Check, Shield, AlertTriangle, BookOpen, Download, Star, Clock } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQ } from '../components/FAQ';
export function SalesPage() {
  const productImageUrl = 'https://cdn.magicpatterns.com/uploads/6tbUPtXW8cGb1PWH4PqZsT/MOCKUPS_FILOSOFIA.png';
  const bonus1Url = 'https://cdn.magicpatterns.com/uploads/4aNtmiycKEziCmVRiCA2wb/bono_1_.png';
  const bonus2Url = 'https://cdn.magicpatterns.com/uploads/h85YjmrEH8ccfJ9S7EM1dx/bono_2_.png';
  const bonus3Url = 'https://cdn.magicpatterns.com/uploads/hdMfk4psySUTKCfZ2cf3MA/bono_3.png';
  // Countdown timer for pricing section
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-12" data-id="element-34">
      <CountdownTimer data-id="element-35" />
      <PurchasePopup data-id="element-36" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-gray-50 to-white py-4 md:py-6 px-4" data-id="element-37">
        <div className="max-w-5xl mx-auto text-center" data-id="element-38">
          <div className="inline-block bg-blue-100 text-blue-800 px-4 py-1 rounded-full font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-39">
            📘 para docentes de filosofia
          </div>

          <h1 className="text-2xl md:text-4xl font-black text-gray-900 mb-2 leading-tight" data-id="element-40">
            ORGANIZA TODO TU AÑO DE FILOSOFIA Y{' '}
            <span className="text-[#16a34a]" data-id="element-41">AHORRA HASTA 12 MESES</span> DE
            PLANIFICACION CON EL KIT COMPLETO FILOSOFIA LISTA
          </h1>

          <div className="mb-0 cursor-pointer transform hover:scale-105 transition-transform duration-300 flex justify-center" onClick={scrollToPurchase} data-id="element-42">
            <img src={productImageUrl} alt="Kit Completo Filosofía Lista" className="w-full max-w-4xl drop-shadow-2xl" data-id="element-43" />
          </div>

          <p className="text-lg md:text-xl text-gray-600 mb-4 max-w-3xl mx-auto" data-id="element-44">
            SISTEMA COMPLETO DE Clases claras y actividades, sin pasar horas
            planificando. Dejá de empezar desde cero cada semana.
          </p>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" className="w-full md:w-auto shadow-xl shadow-green-200" data-id="element-45" />

          <div className="flex flex-wrap justify-center gap-4 mt-4 text-sm text-gray-500 font-medium" data-id="element-46">
            <span className="flex items-center" data-id="element-47">
              <Shield className="w-4 h-4 mr-1 text-green-500" data-id="element-48" /> pago seguro
            </span>
            <span className="flex items-center" data-id="element-49">
              <Download className="w-4 h-4 mr-1 text-green-500" data-id="element-50" /> descarga
              inmediata
            </span>
            <span className="flex items-center" data-id="element-51">
              <Star className="w-4 h-4 mr-1 text-green-500" data-id="element-52" /> garantia de 7
              dias
            </span>
          </div>
        </div>
      </header>

      {/* Problem Agitation */}
      <section className="py-12 bg-gray-50 px-4" data-id="element-53">
        <div className="max-w-3xl mx-auto" data-id="element-54">
          <h2 className="text-3xl font-bold text-center mb-8" data-id="element-55">
            Si enseñás Filosofía, dejame hacerte una pregunta honesta
          </h2>

          <div className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-[#dc2626]" data-id="element-56">
            <h3 className="text-2xl font-bold text-[#dc2626] mb-4" data-id="element-57">
              ¿Te pasa que preparar la clase te cansa más que darla?
            </h3>
            <p className="text-lg mb-4" data-id="element-58">
              No porque no sepas Filosofía. No porque no seas buen docente.
            </p>
            <p className="text-lg font-bold mb-6" data-id="element-59">
              Sino porque cada clase parece empezar desde cero.
            </p>

            <ul className="space-y-3 mb-6" data-id="element-60">
              {['Buscar textos que se entiendan.', 'Pensar actividades que no aburran.', 'Armar consignas que hagan pensar.', 'Preparar evaluaciones sin caer en lo memorístico.', 'Adaptar contenidos abstractos al nivel real del aula.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-61">
                  <AlertTriangle className="w-5 h-5 text-orange-500 mr-3 mt-1 flex-shrink-0" data-id="element-62" />
                  <span className="text-gray-700" data-id="element-63">{item}</span>
                </li>)}
            </ul>

            <p className="text-lg italic text-gray-600 border-t pt-4" data-id="element-64">
              Y cuando finalmente entrás a clase… ya estás cansado/a.
            </p>
          </div>

          <div className="text-center mt-8" data-id="element-65">
            <h3 className="text-2xl font-bold" data-id="element-66">
              👉 Enseñar Filosofía no debería sentirse así.
            </h3>
          </div>
        </div>
      </section>

      {/* Solution */}
      <section className="py-12 px-4" data-id="element-67">
        <div className="max-w-4xl mx-auto" data-id="element-68">
          <div className="text-center mb-12" data-id="element-69">
            <span className="text-green-600 font-bold tracking-widest uppercase" data-id="element-70">
              ✅ LA SOLUCIÓN
            </span>
            <h2 className="text-4xl font-black mt-2 mb-6" data-id="element-71">
              Kit Completo Filosofía Lista
            </h2>
            <p className="text-xl text-gray-600" data-id="element-72">
              Un sistema completo de trabajo docente, organizado y didáctico,
              diseñado para que dejes de improvisar y vuelvas a disfrutar
              enseñar Filosofía.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center mb-12" data-id="element-73">
            {[{
            icon: '📂',
            title: 'Abrís el material'
          }, {
            icon: '👆',
            title: 'Elegís el tema'
          }, {
            icon: '✏️',
            title: 'Lo aplicás en clase'
          }].map((step, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-74">
                <div className="text-4xl mb-4" data-id="element-75">{step.icon}</div>
                <h3 className="font-bold text-xl" data-id="element-76">{step.title}</h3>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-77">
            <p className="text-lg font-medium" data-id="element-78">
              Sin vueltas. Sin fotocopias sueltas. Sin perder tiempo.
            </p>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-12 bg-gray-900 text-white px-4" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-81">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-82">
            <div className="space-y-4" data-id="element-83">
              {['6 cuadernillos completos (1° a 6° año)', 'Teoría clara explicada paso a paso', 'Ejercicios resueltos', 'Actividades prácticas', 'Evaluaciones y diagnósticos', 'Secuencias didácticas por unidad', 'Material visual', 'Planillas docentes'].map((item, i) => <div key={i} className="flex items-center bg-gray-800 p-4 rounded-lg" data-id="element-84">
                  <Check className="w-6 h-6 text-green-400 mr-4 flex-shrink-0" data-id="element-85" />
                  <span className="text-lg font-medium" data-id="element-86">{item}</span>
                </div>)}
            </div>
            <div className="bg-white p-2 rounded-xl transform rotate-2 hover:rotate-0 transition-transform duration-500 flex justify-center" data-id="element-87">
              <img src={productImageUrl} alt="Preview Material" className="w-full rounded-lg" data-id="element-88" />
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-89">
            <p className="text-xl mb-8 text-gray-300" data-id="element-90">
              Todo organizado para encontrar rápido lo que necesitás y cubrir
              todo el programa.
            </p>
            <CTAButton text="👉 ACCEDER CON DESCUENTO" variant="secondary" data-id="element-91" />
          </div>
        </div>
      </section>

      {/* Before vs After */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-92">
        <div className="max-w-4xl mx-auto" data-id="element-93">
          <h2 className="text-3xl font-bold text-center mb-10" data-id="element-94">
            Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-8" data-id="element-95">
            <div className="bg-white p-8 rounded-t-xl md:rounded-xl shadow-sm border-t-4 border-red-500 mb-4 md:mb-0" data-id="element-96">
              <h3 className="text-xl font-bold text-red-600 mb-6 text-center uppercase tracking-wider" data-id="element-97">
                Antes del Kit
              </h3>
              <ul className="space-y-4" data-id="element-98">
                {['Improvisación constante', 'Clases densas o poco participativas', 'Mucho trabajo fuera del aula', 'Estrés antes de cada clase'].map((item, i) => <li key={i} className="flex items-center text-gray-600" data-id="element-99">
                    <span className="w-6 h-6 rounded-full bg-red-100 text-red-500 flex items-center justify-center mr-3 text-sm font-bold" data-id="element-100">
                      ✕
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-white p-8 rounded-b-xl md:rounded-xl shadow-lg border-t-4 border-green-500 transform md:-translate-y-4" data-id="element-101">
              <h3 className="text-xl font-bold text-green-600 mb-6 text-center uppercase tracking-wider" data-id="element-102">
                Después del Kit
              </h3>
              <ul className="space-y-4" data-id="element-103">
                {['Clases claras y organizadas', 'Material listo siempre', 'Más seguridad al explicar', 'Menos desgaste mental', 'Más disfrute al enseñar'].map((item, i) => <li key={i} className="flex items-center text-gray-900 font-medium" data-id="element-104">
                    <Check className="w-6 h-6 text-green-500 mr-3" data-id="element-105" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-12 px-4" data-id="element-106">
        <div className="max-w-5xl mx-auto" data-id="element-107">
          <div className="text-center mb-12" data-id="element-108">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wider mb-4 inline-block" data-id="element-109">
              Sin costo adicional
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900" data-id="element-110">
              🎁 REGALOS ESPECIALES – BONOS INCLUIDOS HOY
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-111">
            {/* Bonus 1 */}
            <div className="flex flex-col items-center" data-id="element-112">
              <div className="relative mb-4 cursor-pointer hover:opacity-90 transition-opacity w-full max-w-[300px] mx-auto" onClick={scrollToPurchase} data-id="element-113">
                <img src={bonus1Url} alt="Bono 1" className="w-full rounded-xl shadow-lg" data-id="element-114" />
                <div className="absolute top-4 right-4 bg-yellow-400 text-black font-bold px-3 py-1 rounded-full text-xs shadow-md" data-id="element-115">
                  HOY GRATIS
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#dc2626] mb-2 text-center" data-id="element-116">
                🎁 Bono #1 – Kit Premium de Evaluaciones de Filosofía
              </h3>
              <p className="text-gray-600 mb-2 text-center" data-id="element-117">
                +50 evaluaciones listas con criterios de corrección.
              </p>
              <p className="text-sm font-bold text-gray-400 line-through text-center" data-id="element-118">
                Valor: $19
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="flex flex-col items-center" data-id="element-119">
              <div className="relative mb-4 cursor-pointer hover:opacity-90 transition-opacity w-full max-w-[300px] mx-auto" onClick={scrollToPurchase} data-id="element-120">
                <img src={bonus2Url} alt="Bono 2" className="w-full rounded-xl shadow-lg" data-id="element-121" />
                <div className="absolute top-4 right-4 bg-yellow-400 text-black font-bold px-3 py-1 rounded-full text-xs shadow-md" data-id="element-122">
                  HOY GRATIS
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#dc2626] mb-2 text-center" data-id="element-123">
                🎁 Bono #2 – Banco de Juegos y Actividades Filosóficas
              </h3>
              <p className="text-gray-600 mb-2 text-center" data-id="element-124">
                Más de 30 recursos lúdicos para motivar tus clases.
              </p>
              <p className="text-sm font-bold text-gray-400 line-through text-center" data-id="element-125">
                Valor: $15
              </p>
            </div>

            {/* Bonus 3 */}
            <div className="flex flex-col items-center" data-id="element-126">
              <div className="relative mb-4 cursor-pointer hover:opacity-90 transition-opacity w-full max-w-[300px] mx-auto" onClick={scrollToPurchase} data-id="element-127">
                <img src={bonus3Url} alt="Bono 3" className="w-full rounded-xl shadow-lg" data-id="element-128" />
                <div className="absolute top-4 right-4 bg-yellow-400 text-black font-bold px-3 py-1 rounded-full text-xs shadow-md" data-id="element-129">
                  HOY GRATIS
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#dc2626] mb-2 text-center" data-id="element-130">
                🎁 Bono #3 – Plantillas Profesionales de Planificación
              </h3>
              <p className="text-gray-600 mb-2 text-center" data-id="element-131">
                Modelos semanales y mensuales para organizar todo el año.
              </p>
              <p className="text-sm font-bold text-gray-400 line-through text-center" data-id="element-132">
                Valor: $12
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase" className="py-16 bg-gray-900 text-white px-4" data-id="element-133">
        <div className="max-w-4xl mx-auto bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden border-4 border-yellow-400" data-id="element-134">
          <div className="bg-yellow-400 p-4 text-center" data-id="element-135">
            <p className="font-black text-xl md:text-2xl uppercase tracking-widest mb-2" data-id="element-136">
              ⏰ Oferta por tiempo limitado
            </p>
            <div className="flex items-center justify-center gap-2 font-bold text-lg md:text-xl text-gray-900" data-id="element-137">
              <Clock className="h-5 w-5" data-id="element-138" />
              <span data-id="element-139">Expira en: {formatTime(timeLeft)}</span>
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-140">
            <h2 className="text-3xl font-bold text-center mb-8" data-id="element-141">
              Accedé al Kit Completo Filosofía Lista + los 3 Bonos de regalo
            </h2>

            <div className="bg-gray-50 p-6 rounded-xl mb-8 border border-gray-200" data-id="element-142">
              <h3 className="font-bold text-lg mb-4 text-gray-500 uppercase tracking-wide" data-id="element-143">
                📦 Lo que vas a recibir hoy:
              </h3>
              <ul className="space-y-3" data-id="element-144">
                <li className="flex items-center font-bold text-lg" data-id="element-145">
                  <Check className="w-5 h-5 text-green-500 mr-3" data-id="element-146" />
                  Todos los materiales de Filosofía del Kit Completo
                </li>
                <li className="flex items-center" data-id="element-147">
                  <Check className="w-5 h-5 text-green-500 mr-3" data-id="element-148" />
                  <span className="font-bold mr-1" data-id="element-149">Bono #1:</span> Kit Premium
                  de Evaluaciones
                </li>
                <li className="flex items-center" data-id="element-150">
                  <Check className="w-5 h-5 text-green-500 mr-3" data-id="element-151" />
                  <span className="font-bold mr-1" data-id="element-152">Bono #2:</span> Maletín de
                  Actividades
                </li>
                <li className="flex items-center" data-id="element-153">
                  <Check className="w-5 h-5 text-green-500 mr-3" data-id="element-154" />
                  <span className="font-bold mr-1" data-id="element-155">Bono #3:</span> Plantillas
                  Profesionales de Planificacion
                </li>
              </ul>
            </div>

            <div className="text-center mb-8" data-id="element-156">
              <p className="text-gray-500 text-lg mb-2" data-id="element-157">
                Precio regular:{' '}
                <span className="line-through" data-id="element-158">ARS $49.990</span>
              </p>
              <p className="text-5xl md:text-7xl font-black text-[#dc2626] tracking-tight mb-4" data-id="element-159">
                ARS $19.990
              </p>
              <p className="text-sm text-gray-500 font-medium uppercase tracking-widest mb-8" data-id="element-160">
                HOY SOLO
              </p>

              <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-600 mb-8" data-id="element-161">
                <span className="flex items-center" data-id="element-162">
                  <Check className="w-4 h-4 mr-1 text-green-500" data-id="element-163" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center" data-id="element-164">
                  <Check className="w-4 h-4 mr-1 text-green-500" data-id="element-165" /> Un solo pago
                </span>
                <span className="flex items-center" data-id="element-166">
                  <Check className="w-4 h-4 mr-1 text-green-500" data-id="element-167" /> Descarga
                  digital
                </span>
                <span className="flex items-center" data-id="element-168">
                  <Check className="w-4 h-4 mr-1 text-green-500" data-id="element-169" /> Acceso de
                  por vida
                </span>
              </div>

              <a href="https://checkout.kitonline.shop/cart/47637808611566:1" className="inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 transform hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-offset-2 bg-[#16a34a] hover:bg-[#15803d] text-white border-b-4 border-[#166534] focus:ring-green-500 w-full py-6 text-xl md:text-2xl rounded-lg shadow-2xl animate-pulse" data-id="element-170">
                👉 OBTENER MI KIT COMPLETO HOY
              </a>
            </div>

            <div className="flex items-center justify-center gap-2 opacity-60 grayscale" data-id="element-171">
              <div className="h-8 bg-gray-200 w-12 rounded" data-id="element-172"></div>
              <div className="h-8 bg-gray-200 w-12 rounded" data-id="element-173"></div>
              <div className="h-8 bg-gray-200 w-12 rounded" data-id="element-174"></div>
              <div className="h-8 bg-gray-200 w-12 rounded" data-id="element-175"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-176">
        <div className="max-w-3xl mx-auto text-center" data-id="element-177">
          <div className="inline-block p-4 rounded-full bg-white shadow-lg mb-6" data-id="element-178">
            <Shield className="w-16 h-16 text-blue-600" data-id="element-179" />
          </div>
          <h2 className="text-3xl font-bold mb-4" data-id="element-180">🛡️ Garantía sin riesgo</h2>
          <p className="text-xl text-gray-600" data-id="element-181">
            Probalo durante 7 días. Si no es para vos, te devolvemos el 100% del
            dinero. Sin preguntas.
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 px-4" data-id="element-182">
        <div className="max-w-6xl mx-auto" data-id="element-183">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-184">
            💬 Lo que dicen otros docentes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-185">
            <TestimonialCard name="María G." role="Profesora de Filosofía, Buenos Aires" quote="Antes improvisaba mucho. Ahora entro a clase con todo listo." data-id="element-186" />
            <TestimonialCard name="Carlos R." role="Docente de Secundaria, Córdoba" quote="Me ahorra muchísimo tiempo. Las actividades realmente funcionan." data-id="element-187" />
            <TestimonialCard name="Ana M." role="Profesora de Filosofía, Rosario" quote="Mis alumnos participan más y yo explico con más seguridad." data-id="element-188" />
            <TestimonialCard name="Lucía T." role="Docente de Filosofía, Mendoza" quote="El material es claro y está muy bien organizado. Mis clases mejoraron notablemente." data-id="element-189" />
            <TestimonialCard name="Roberto S." role="Profesor de Secundaria, La Plata" quote="Finalmente puedo dedicar tiempo a enseñar en lugar de solo preparar." data-id="element-190" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-191">
        <div className="max-w-3xl mx-auto" data-id="element-192">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-193">
            ❓ Preguntas frecuentes
          </h2>
          <FAQ data-id="element-194" />
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 text-center" data-id="element-195">
        <div className="max-w-3xl mx-auto" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-197">
            Enseñar Filosofía puede ser más simple
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-198">
            No necesitás más material. Necesitás un sistema que te sostenga todo
            el año.
          </p>
          <CTAButton text="👉 Accedé ahora al Kit Completo Filosofía Lista" className="w-full md:w-auto" data-id="element-199" />
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-200">
        <p data-id="element-201">
          © {new Date().getFullYear()} Kit Completo Filosofía Lista. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}